/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Screen_OrdersInputs */

const vi_station_screen_orders = /** @type {(inputs: Station_Screen_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng`)
};

/**

* @param {Station_Screen_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_screen_orders = /** @type {((inputs?: Station_Screen_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Screen_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_screen_orders(inputs)
});